import { createConfigLoader } from "@/config";
import { DealType } from "@/enums/dealType";
import { PropertyCategory } from "@/enums/propertyCategory";
import { PropertyType } from "@/enums/propertyType";

export interface IObjectTypeItem {
  label: string;
  value: PropertyCategory;
}

export interface IObjectTypeConfig {
  objectTypeItems: (t: any) => IObjectTypeItem[];
  validPropertyTypesByDealType: Record<DealType, PropertyType[]>;
}

// Default object type configuration
const defaultObjectTypeConfig: IObjectTypeConfig = {
  objectTypeItems: (t: any) => [
    { label: t("From the developer"), value: PropertyCategory.PRIMARY },
    { label: t("Sale"), value: PropertyCategory.SECONDARY_BUY },
    { label: t("Rent"), value: PropertyCategory.SECONDARY_RENTAL },
  ],
  validPropertyTypesByDealType: {
    [DealType.PRIMARY]: [
      PropertyType.PRIMARY_RESIDENTIAL,
      PropertyType.PRIMARY_COMMERCIAL,
      PropertyType.PRIMARY_HOTELS,
    ],
    [DealType.BUY]: [
      PropertyType.BUY_RESIDENTIAL,
      PropertyType.BUY_COMMERCIAL,
      PropertyType.BUY_LAND,
    ],
    [DealType.RENT]: [
      PropertyType.RENT_RESIDENTIAL,
      PropertyType.RENT_COMMERCIAL,
    ],
  },
};

// Load configuration with country-specific overrides
const objectTypeConfigData = createConfigLoader(
  defaultObjectTypeConfig,
  "objectType",
);

// Export for backward compatibility
export const objectTypeConfig = objectTypeConfigData.objectTypeItems;
export const validPropertyTypesByDealType =
  objectTypeConfigData.validPropertyTypesByDealType;
